import React from 'react';
import { render } from 'react-dom';
const robotsText = `User-agent: ia_archiver
Disallow: /

User-agent: CCBot
Disallow: /

User-agent: ArchiveBot
Disallow: /

User-agent: bl.uk_lddc_bot
Disallow: /
`;
if (window.location.pathname === '/robots.txt') {
  document.title = 'robots.txt';
  document.head.replaceChildren();
  document.body.replaceChildren(document.createTextNode(robotsText));
} else {
  void import('./index.css').then(() => import('./App').then(({
    App
  }) => {
    const root = document.getElementById('root');
    if (root) {
      render(<App data-id="element-349" data-mp="2f7vzzzki832e" />, root);
    }
  }));
}